// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"0d4d695f","297":"b1ad2fa6","482":"4b8a6d42","511":"2c5d5542","516":"4f877f07","526":"61036764","554":"3a49bc1b","594":"5bf8b269","713":"c716ca9f","964":"22626a27"}[chunkId] + ".chunk.js";
};